import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface AuthLayoutWrapperProps {
  readonly children: ReactNode;
  readonly illustrationSrc?: string;
  readonly className?: string;
}

/**
 * Auth layout wrapper with split-screen design (inverted from onboarding):
 * - Left side: Form content
 * - Right side: Illustration (desktop only)
 */
export function AuthLayoutWrapper({ 
  children, 
  illustrationSrc,
  className 
}: AuthLayoutWrapperProps) {
  return (
    <div className={cn("h-screen overflow-hidden bg-black flex", className)}>
      {/* Left column - Form content */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-md">
          {children}
        </div>
      </div>

      {/* Right column - Illustration (desktop only) */}
      <div className="hidden md:flex md:w-1/2 bg-black p-4">
        <div className="relative w-full h-full rounded-2xl overflow-hidden">
          {illustrationSrc ? (
            <img 
              src={illustrationSrc} 
              alt="Illustration" 
              className="w-full h-full object-cover object-[center_30%]"
            />
          ) : (
            <div className="w-full h-full bg-white/5 flex items-center justify-center">
              <span className="text-white/20 text-sm">Illustration</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
